import React, { useEffect, useState } from 'react';
import { priceToString } from 'shared/utils';
import { getSubscriptionProration } from 'shared/api/subscription';
import { useRequest } from 'shared/hooks';

/**
 * @param {Object} props
 * @param {number} props.currentPrice - Current subscription price
 * @param {string} props.newPlanId - New plan ID
 * @param {number} props.newPrice - New subscription price
 * @param {number} props.tenantId - Tenant ID
 */
export default function Prorate(props) {
  const {
    currentPrice,
    newPlanId,
    newPrice,
    tenantId,
  } = props;

  const { request } = useRequest();
  const [proration, setProration] = useState(undefined);

  useEffect(() => {
    (async () => {
      const result = await request(getSubscriptionProration(tenantId, newPlanId));
      if (result) {
        setProration(result.proration);
      }
    })();
  }, [tenantId, newPlanId, request]);

  if (newPrice === 0 || currentPrice === newPrice || proration === undefined) {
    return null;
  }

  const prorationString = priceToString(Math.abs(proration));
  return (
    <div>
      <p>
        This will change the billing price from
        <strong>
          {` $${priceToString(currentPrice)}/month `}
        </strong>
        to
        <strong>
          {` $${priceToString(newPrice)}/month`}
        </strong>
      </p>
      <p>
        {proration === 0 && "This won't generate any immediate charges or credits."}
        {proration > 0 && (
          <>
            This will create an immediate charge for
            <strong>{` ${prorationString} `}</strong>
            due to proration.
          </>
        )}
        {proration < 0 && (
          <>
            This will add a credit of
            <strong>{` $${prorationString} `}</strong>
            to the account.
          </>
        )}
      </p>
    </div>
  );
}
